import config from '@/lib/config';
import NetworkClient from '@/lib/network/client';

const client = new (class HubspotNetworkClient extends NetworkClient {
  config = {
    baseURL: config.HUBSPOT_URL,

    transformData: ({ data } = {}) => data?.result,

    onError: (error) => {
      console.error('Error sending Hubspot request:', error);
    },
  };
})();

async function sendEvent(email, eventName, properties = null) {
  try {
    return await client.post('/event', {
      email,
      eventName,
      properties: {
        ...(properties ?? {}),
        eventSource: 'APP',
      },
    });
  } catch (err) {
    console.error(`Unable to send beta event ${eventName} to Hubspot:`, err);
  }
}

/**
 * Send a shiny new (beta) Custom Behavioral Event to Hubspot (as opposed to the
 * older, stankier Legacy event).
 *
 * @param {String} email User email event is about
 * @param {String} eventName Name of event to fire
 * @param {Object} properties Object of properties to send along with the event
 */
export function event(email, eventName, properties = null) {
  if (config.DISABLE_HUBSPOT) {
    console.info(
      `Skipping sending Hubspot event ${eventName}: DISABLE_HUBSPOT flag is set.`,
    );

    return;
  }

  return sendEvent(email, eventName, properties);
}
